import { useAppStateContext } from '../../../AppStateProvider/AppStateProvider';
import { Button, Container, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Success from './SuccessNew.png';
import { ViewIcon } from '../../../../icons/ViewIcon';

const Header = styled(Grid)(({ theme }) => ({
  float: 'left',
  [theme.breakpoints.down('md')]: {
    float: 'initial',
  },
}));

const IllustrationContainer = styled(Grid)(({ theme }) => ({
  float: 'right',
  marginRight: '1em',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    float: 'initial',
    justifyContent: 'center',
    margin: '0 0 2.5em 0',
  },
}));

const Illustration = styled('img')({
  width: '245px',
  height: '200px',
});

const ViewButton = styled(Button)({
  marginTop: '2em',
  '& svg': {
    position: 'relative',
    left: '-5px',
  },
});

const OkButton = styled(Grid)(({ theme }) => ({
  clear: 'left',
  [theme.breakpoints.down('md')]: {
    clear: 'initial',
    marginBottom: '2em',
  },
}));

interface ConnectionSuccessProps {
  openModal: () => void;
}

export function ConnectionSuccess({ openModal }: ConnectionSuccessProps) {
  const { nextPane } = useAppStateContext();

  return (
    <>
      <Container>
        <div>
          <Header item lg={5}>
            <Typography variant="h1" gutterBottom>
              Connection success
            </Typography>

            <Typography variant="body1" gutterBottom>
              All connections to Twilio's servers are working correctly.
            </Typography>
          </Header>

          <IllustrationContainer item lg={5}>
            <Illustration src={Success} alt="Success" />
            <ViewButton variant="outlined" onClick={openModal}>
              <ViewIcon />
              View detailed connection information
            </ViewButton>
          </IllustrationContainer>

          <OkButton item lg={5}>
            <Button variant="contained" color="primary" onClick={nextPane}>
              Ok
            </Button>
          </OkButton>
        </div>
      </Container>
    </>
  );
}
